
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrdersDialog extends Serenity.EntityDialog<OrdersRow, any> {
        protected getFormKey() { return OrdersForm.formKey; }
        protected getIdProperty() { return OrdersRow.idProperty; }
        protected getLocalTextPrefix() { return OrdersRow.localTextPrefix; }
        protected getNameProperty() { return OrdersRow.nameProperty; }
        protected getService() { return OrdersService.baseUrl; }
        protected getDeletePermission() { return OrdersRow.deletePermission; }
        protected getInsertPermission() { return OrdersRow.insertPermission; }
        protected getUpdatePermission() { return OrdersRow.updatePermission; }

        protected form = new OrdersForm(this.idPrefix);

        /*  private orderProductSpecificationsGrid: OrderProductSpecificationsGrid;*/
        private orderShippingGrid: OrderShippingGrid1;
        private OrderPaymentGrid: OrderPaymentGrid;
        private orderProductBillingItemsGrid: OrderProductBillingItemsGrid;
        private orderInstallmentsGrid: OrderInstallmentsGrid;
        private orderGiftCardsGrid: OrderGiftCardsGrid1;
        private orderBookGrid: OrderBookGrid;
        private loadedState: string;
        public OrderStatus: number;
        constructor() {
            super();

            this.orderBookGrid = new OrderBookGrid(this.byId("OrderBookGrid"));
            this.orderBookGrid.element.flexHeightOnly(1);

            this.orderShippingGrid = new OrderShippingGrid1(this.byId("OrderShippingGrid1"));
            this.orderShippingGrid.element.flexHeightOnly(1);
         

            this.orderGiftCardsGrid = new OrderGiftCardsGrid1(this.byId("OrderGiftCardsGrid1"));
            this.orderGiftCardsGrid.element.flexHeightOnly(1);

            this.orderInstallmentsGrid = new OrderInstallmentsGrid(this.byId("OrderInstallmentsGrid"));
            this.orderInstallmentsGrid.element.flexHeightOnly(1);

            this.OrderPaymentGrid = new OrderPaymentGrid(this.byId("OrderPaymentGrid"));
            this.OrderPaymentGrid.element.flexHeightOnly(1);

            this.orderProductBillingItemsGrid = new OrderProductBillingItemsGrid(this.byId("OrderProductBillingItemsGrid"));
            this.orderProductBillingItemsGrid.element.flexHeightOnly(1);

            DialogUtils.pendingChangesConfirmation(this.element, () => this.getSaveState() != this.loadedState);
            this.tabs.on('tabsactivate', (e, i) => { this.arrange() });
          
         
            //this.form.PaymentType.changeSelect2(() => {
            //    debugger;
            //    if (this.isNew()) {
            //        var Pstatus = this.form.PaymentType.value;
            //        if (Pstatus != "") {
            //            if (Number(Pstatus) == 1 || Number(Pstatus) == 4) {

            //                Serenity.EditorUtils.setRequired(this.form.PaymentMode, false);
            //                Serenity.EditorUtils.setRequired(this.form.Amount, false);
            //                this.form.PaymentMode.getGridField().toggle(false);
            //                this.form.BankName.getGridField().toggle(false);
            //                this.form.ChequeNumber.getGridField().toggle(false);
            //                this.form.TransactionId.getGridField().toggle(false);
            //                this.form.PaymentDate.getGridField().toggle(false);
            //                this.form.Amount.getGridField().toggle(false);
            //            }

            //            else {

            //                this.form.PaymentMode.getGridField().toggle(true);
            //                this.form.BankName.getGridField().toggle(true);
            //                this.form.ChequeNumber.getGridField().toggle(true);
            //                this.form.TransactionId.getGridField().toggle(true);
            //                this.form.PaymentDate.getGridField().toggle(true);
            //                this.form.Amount.getGridField().toggle(true);
            //                Serenity.EditorUtils.setRequired(this.form.PaymentMode, true);
            //                Serenity.EditorUtils.setRequired(this.form.Amount, true);
            //            }
            //        }
            //        else {
            //            Serenity.EditorUtils.setRequired(this.form.PaymentMode, false);
            //            Serenity.EditorUtils.setRequired(this.form.Amount, false);
            //            this.form.PaymentMode.getGridField().toggle(false);
            //            this.form.BankName.getGridField().toggle(false);
            //            this.form.ChequeNumber.getGridField().toggle(false);
            //            this.form.TransactionId.getGridField().toggle(false);
            //            this.form.PaymentDate.getGridField().toggle(false);
            //            this.form.Amount.getGridField().toggle(false);
            //        }
            //    }
            //});

            this.form.ESourceType.changeSelect2(e => {
                var vSourceType = this.form.ESourceType.value;

                if (Q.isEmptyOrNull(vSourceType)) {
                    // this.setProductDetails({});
                    this.form.EFranchiseeDiscount.getGridField().toggle(false);
                    this.form.FranchiseeDiscountAmount.getGridField().toggle(false);
                    this.form.EFranchiseeDiscountType.getGridField().toggle(false);
                    this.form.FranchiseeDiscountValue.getGridField().toggle(false);
                    this.form.FranchiseeId.getGridField().toggle(false);

                }
                else {

                    if (vSourceType == '2' || vSourceType == '4' || vSourceType == '3') {

                        if (vSourceType == '2') {
                            this.form.EInvoiceTo.value = '2';
                            this.form.EFranchiseeDiscount.getGridField().toggle(true);
                            this.form.FranchiseeDiscountAmount.getGridField().toggle(true);
                            this.form.EFranchiseeDiscountType.getGridField().toggle(true);
                            this.form.FranchiseeDiscountValue.getGridField().toggle(true);
                            this.form.FranchiseeId.getGridField().toggle(true);
                            this.form.EPaymentType.value = '2';
                        }
                        else if (vSourceType == '4') {
                            this.form.EFranchiseeDiscount.getGridField().toggle(false);
                            this.form.FranchiseeDiscountAmount.getGridField().toggle(false);
                            this.form.EFranchiseeDiscountType.getGridField().toggle(false);
                            this.form.FranchiseeDiscountValue.getGridField().toggle(false);
                            this.form.FranchiseeId.getGridField().toggle(false);
                            this.form.EInvoiceTo.value = '1';
                            this.form.EPaymentType.value = '2';
                        }
                        else
                        {
                            this.form.EInvoiceTo.value = '1';
                            this.form.EPaymentType.value = '2';
                        }
                    }
                    else
                    {
                        this.form.EInvoiceTo.value = '1';
                        this.form.EPaymentType.value = '3';
                    }
                }
            });
        }

        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }
        private seCustomDetails(details: Orders.OrdersRow) {


            this.form.CustomerName1.value = details.CustomerName1;
            this.form.CustomerMobile11.value = details.CustomerMobile11;
            this.form.CustomerMobile21.value = details.CustomerMobile21;
            this.form.CustomerEmail1.value = details.CustomerEmail1;
            this.form.CustomerEmail2.value = details.CustomerEmail2;

            /*this.form.ShippingAddress1.value = details.ShippingAddress1;
            this.form.ShippingAddress2.value = details.ShippingAddress2;*/
        }

        private setCustomDetails(details: Orders.OrdersRow) {


            this.form.BillingAddress1.value = details.BillingAddress1;
            this.form.BillingAddress2.value = details.BillingAddress2;
            this.form.BillingCity.value = details.BillingCity;
            this.form.BillingStateId.value = details.BillingStateId.toString();
            this.form.Gstin.value = details.CustomerGstin;
            this.form.BillingPincode.value = details.BillingPincode;
        }
        private seEntityDetails(details: Users.CustomersRow) {
            //debugger;

            this.form.CustomerName1.value = details.Name;
            this.form.CustomerMobile11.value = details.Mobile1;
            this.form.CustomerMobile21.value = details.Mobile2;
            this.form.CustomerEmail1.value = details.EmailId1;
            this.form.CustomerEmail2.value = details.EmailId2;
            this.form.Gstin.value = details.Gstin;
        }
        private seAddressEntityDetails(details: Users.CustomerAddressRow) {
            //debugger;

            /*this.form.ShippingAddress1.value = details.Address1;
            this.form.ShippingAddress2.value = details.Address2;*/
        }
        loadResponse(data) {
            super.loadResponse(data);
            Serenity.TabsExtensions.setDisabled(this.tabs, 'OrderProductSpecifications', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'OrderBookGrid', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'OrderShipping', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'OrderPayment', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'OrderProductBillingItems', this.isNewOrDeleted());
            Serenity.TabsExtensions.setDisabled(this.tabs, 'OrderInstallments', this.isNewOrDeleted());
            Serenity.TabsExtensions.setDisabled(this.tabs, 'orderGiftCards', this.isNewOrDeleted());

            this.loadedState = this.getSaveState();
        }

        loadEntity(entity: OrdersRow)
        {
            super.loadEntity(entity);
            //debugger;
            if (this.isNew()) {
                this.form.InvoiceCompanyId.value = '1';
                this.form.EFranchiseeDiscount.getGridField().toggle(false);
                this.form.FranchiseeDiscountAmount.getGridField().toggle(false);
                this.form.EFranchiseeDiscountType.getGridField().toggle(false);
                this.form.FranchiseeDiscountValue.getGridField().toggle(false);
                this.form.FranchiseeId.getGridField().toggle(false);
                this.form.OrderInstallments.getGridField().toggle(false);

                //        this.form.PaymentMode.getGridField().toggle(false);
                //        this.form.BankName.getGridField().toggle(false);
                //        this.form.ChequeNumber.getGridField().toggle(false);
                //        this.form.TransactionId.getGridField().toggle(false);
                //        this.form.PaymentDate.getGridField().toggle(false);
                //        this.form.Amount.getGridField().toggle(false);
                //        this.element.find(".send-button").toggle(false);
                //        this.element.find(".Add-button").toggle(false);
            }
            else {
                this.form.OrderInstallments.getGridField().toggle(true);
                Serenity.EditorUtils.setReadonly(this.form.DiscountAmount.element, true);
                if (this.form.FreezeData.value != true) {
                    this.element.find(".bg-olive").toggle(true);
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
                    this.element.find(".bg-olive").toggle(false);

                }
            }

            this.form.CustomerId.change(e => {
                var vcustomerId = this.form.CustomerId.value;

                if (Q.isEmptyOrNull(vcustomerId)) {
                    // this.setProductDetails({});

                }
                else {

                    try {

                        Orders.OrdersService.GetDetail({
                            CustomerId: parseInt(vcustomerId)
                            //      
                        }, response => {
                            this.form.CustomerId.value = this.form.CustomerId.value;
                            this.form.CustomerName1.value = response.CustomerName;
                            this.form.CustomerMobile11.value = response.CustomerMobile1;
                            this.form.CustomerMobile21.value = response.CustomerMobile2;
                            this.form.CustomerEmail1.value = response.CustomerEmail1;
                            this.form.CustomerEmail2.value = response.CustomerEmail2;
                            this.form.Gstin.value = response.GSTIN;

                            /*this.form.ShippingAddress1.value = response.ShippingAddress1;
                            this.form.ShippingAddress2.value = response.ShippingAddress2;
                            this.form.ShippingCity.value = response.City;
                            this.form.ShippingStateId.value = response.State.toString();
                            this.form.ShippingPincode.value = Number(response.Pincode);*/

                            this.form.BillingAddress1.value = response.BillingAddress1;
                            this.form.BillingAddress2.value = response.BillingAddress2;
                            this.form.BillingCity.value = response.BillingCity;
                            this.form.BillingStateId.value = response.BillingState.toString();
                            this.form.Gstin.value = response.BillingGSTIN;
                            this.form.BillingPincode.value = Number(response.BillingPincode);


                            /*this.form.CustomerName1.value = response.Entity.CustomerName;
                            this.form.CustomerMobile11.value = response.Entity.CustomerMobile1;
                            this.form.CustomerMobile21.value = response.Entity.CustomerMobile2;
                            this.form.CustomerEmail1.value = response.Entity.CustomerEmailId1;
                            this.form.CustomerEmail2.value = response.Entity.CustomerEmailId2;
    
                            this.form.ShippingAddress1.value = response.Entity.Address1;
                            this.form.ShippingAddress2.value = response.Entity.Address2;
                            this.form.ShippingCity.value = response.Entity.City;
                            this.form.ShippingStateId.value = response.Entity.StateId.toString();
                            this.form.Gstin.value = response.Entity.CustomerGstin;
                            this.form.ShippingPincode.value = Number(response.Entity.PinCode);
    
                            this.form.BillingAddress1.value = response.Entity.Address1;
                            this.form.BillingAddress2.value = response.Entity.Address2;
                            this.form.BillingCity.value = response.Entity.City;
                            this.form.BillingStateId.value = response.Entity.StateId.toString();
                            this.form.Gstin.value = response.Entity.CustomerGstin;
                            this.form.BillingPincode.value = Number(response.Entity.PinCode);*/
                        });


                    } catch (e) {

                    }
                    //Orders.OrdersService.Retrieve2({
                    //    EntityId: id1
                    //}, response => {
                    //        this.seCustomDetails(response.Entity);
                    //});

                    /*Users.FranchiseeService.Retrieve({
                        EntityId: parseInt(vfranchiseeId)
                    }, response => {
                            this.setCustomDetails(response.Entity);
                    });*/

                }

            });

            this.form.FranchiseeId.change(e => {
                var vfranchiseeId = this.form.FranchiseeId.value;

                if (Q.isEmptyOrNull(vfranchiseeId)) {
                    this.form.BillingAddress2.value = this.form.BillingAddress2.value;
                    /*this.form.BillingAddress1.value = this.form.ShippingAddress1.value;                    
                    this.form.BillingCity.value = this.form.ShippingCity.value;
                    this.form.BillingStateId.value = this.form.ShippingStateId.value;
                    this.form.BillingPincode.value = this.form.ShippingPincode.value;*/
                }
                else {

                    try {

                        Users.FranchiseeService.Retrieve({
                            EntityId: parseInt(vfranchiseeId)
                            //      
                        }, response => {

                            /*this.form.CustomerName1.value = response.Entity.CustomerName;
                            this.form.CustomerMobile11.value = response.Entity.CustomerMobile1;
                            this.form.CustomerMobile21.value = response.Entity.CustomerMobile2;
                            this.form.CustomerEmail1.value = response.Entity.CustomerEmailId1;
                            this.form.CustomerEmail2.value = response.Entity.CustomerEmailId2;*/

                            /*this.form.ShippingAddress1.value = response.Entity.Address1;
                            this.form.ShippingAddress2.value = response.Entity.Address2;
                            this.form.ShippingCity.value = response.Entity.City;
                            this.form.ShippingStateId.value = response.Entity.StateId.toString();
                            this.form.Gstin.value = response.Entity.CustomerGstin;
                            this.form.ShippingPincode.value = Number(response.Entity.PinCode);*/

                            this.form.BillingAddress1.value = response.Entity.Address;
                            this.form.BillingAddress2.value = response.Entity.Address;
                            this.form.BillingCity.value = response.Entity.City;
                            this.form.BillingStateId.value = response.Entity.StateId.toString();
                            this.form.Gstin.value = response.Entity.CustomerGstin;
                            this.form.BillingPincode.value = Number(response.Entity.Pincode);
                        });


                    } catch (e) {

                    }
                    //Orders.OrdersService.Retrieve2({
                    //    EntityId: id1
                    //}, response => {
                    //        this.seCustomDetails(response.Entity);
                    //});

                    /*Users.FranchiseeService.Retrieve({
                        EntityId: parseInt(vfranchiseeId)
                    }, response => {
                        this.setCustomDetails(response.Entity);
                    });*/

                }

            });
            //this.form.StateId.changeSelect2(e => {
            //    var vStateId = this.form.StateId.value;
            //    //debugger;
            //    if (Q.isEmptyOrNull(vStateId)) {
            //        // this.setProductDetails({});

            //    }
            //    else {
            //        var id1 = vStateId;

            //        this.form.OrderProducts.stateid = parseInt(vStateId);
            //    }

            //});
            // Q.reloadLookup("Workspace.ActiveProduct");
            Serenity.TabsExtensions.setDisabled(this.tabs, 'OrderProductSpecifications', this.isNewOrDeleted());
            Serenity.TabsExtensions.setDisabled(this.tabs, 'OrderBookGrid', this.isNewOrDeleted());
            Serenity.TabsExtensions.setDisabled(this.tabs, 'OrderShipping', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'OrderPayment', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'OrderProductBillingItems', this.isNewOrDeleted());
            Serenity.TabsExtensions.setDisabled(this.tabs, 'OrderInstallments', this.isNewOrDeleted());
            Serenity.TabsExtensions.setDisabled(this.tabs, 'orderGiftCards', this.isNewOrDeleted());

            if (!Authorization.hasPermission("Administration:Security")) {
                //if (Authorization.hasPermission("Workspace:Institute") || Authorization.hasPermission("Workspace:InstituteSupportStaff"))
                //AssessmentPermissionKeys.Application + "|" + AssessmentPermissionKeys.Publisher
                //{

                //}
                if (Authorization.hasPermission("Users:Franchisee")) {
                    //this.form.TenantId.value = Authorization.userDefinition.TenantId.toString();
                    this.form.ESourceType.value = "2";
                    Serenity.EditorUtils.setReadonly(this.form.ESourceType.element, true);
                    Serenity.EditorUtils.setRequired(this.form.FranchiseeId, true);

                }
            }

            this.orderBookGrid.OrderId = entity.Id;
            this.orderShippingGrid.OrderId = entity.Id;
            //this.orderShippingGrid.ShippingProviderId = this.entity.ShippingProviderId;
            this.OrderPaymentGrid.OrderId = entity.Id;
            this.orderProductBillingItemsGrid.OrderId = entity.Id;
            this.orderInstallmentsGrid.OrderId = entity.Id;
        }


        protected afterLoadEntity() {
            super.afterLoadEntity();
            let orderId = this.entityId;
            this.orderBookGrid.OrderId = this.entityId;
            this.orderShippingGrid.OrderId = this.entityId;
            //this.orderShippingGrid.ShippingProviderId = this.entity.ShippingProviderId;
            this.OrderPaymentGrid.OrderId = this.entityId;
            this.orderProductBillingItemsGrid.OrderId = this.entityId;
            this.orderInstallmentsGrid.OrderId = this.entityId;
            this.orderGiftCardsGrid.OrderId = this.entityId;

            //Passing discount to OrderProduct Editor

            //  this.form.OrderProducts.TenantId = Number(this.form.TenantId.value);
            if (this.form.FreezeData.value == true) {
                Serenity.TabsExtensions.setDisabled(this.tabs, 'OrderProductSpecifications', true);

            }
        }

        protected validateBeforeSave() {
            var isValidate = super.validateForm();
            if (isValidate) {
                isValidate = super.validateBeforeSave();
            }
            //if (this.form.OrderProducts.rowCount() == 0) {
            //    Q.alert("At least one Product is mandatory for Order.");
            //    return false;
            //}
            return isValidate;
        }

        protected updateInterface(): void {

            super.updateInterface();
            if (Authorization.hasPermission("Users:Franchisee") && !Authorization.hasPermission("Administration:Security")) {

                this.OrderStatus = Number(this.form.EOrderStatus.value);
                if (this.OrderStatus > 2) {
                    Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
                    this.deleteButton.toggleClass('disabled', true);
                    this.saveAndCloseButton.toggleClass('disabled', true);
                    this.applyChangesButton.toggleClass('disabled', true);
                }


            }
            if (this.form.FreezeData.value == true) {
                this.deleteButton.toggleClass('disabled', true);
                this.saveAndCloseButton.toggleClass('disabled', true);
                this.applyChangesButton.toggleClass('disabled', true);
                Serenity.TabsExtensions.setDisabled(this.tabs, 'OrderProductSpecifications', this.isNewOrDeleted());

            }
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            buttons.push({
                title: Q.text('Freeze Order'),
                cssClass: 'bg-olive',
                icon: 'fa fa-lock text-green',
                onClick: () => {
                    Q.confirm("Are you sure You want to Freeze Order?", () => {
                        this.form.FreezeData.value = true;
                        this.saveAndCloseButton.click();
                    });

                }
            });

            buttons.push({
                title: Q.text('Add Book'),
                cssClass: 'bg-olive',
                separator: true,
                icon: 'fa-solid fa-book',
                onClick: () => {
                    Q.confirm("Are you sure You want to Add Book?", () => {
                        var orderId = this.form.OrderNumber.value;
                        this.openAddBookDialog();
                    });
                }
            });

            return buttons;
        }

        private openAddBookDialog() {
            let dlg = new AddBookDialog(this.entityId);
            dlg.loadEntityAndOpenDialog(this.get_entityId());
        }

        

    }
}